import {css, view} from '@sail/ui/deprecated';

// Array of valid avatar emojis
export const AVATAR_EMOJIS = [
  '\u{1F436}',
  '\u{1F431}',
  '\u{1F430}',
  '\u{1F98A}',
  '\u{1F438}',
  '\u{1F437}',
  '\u{1F435}',
  '\u{1F43C}',
  '\u{1F419}',
  '\u{1F433}',
  '\u{1F984}',
  '\u{1F414}',
  '\u{1F427}',
  '\u{1F426}',
  '\u{1F424}',
  '\u{1F341}',
  '\u{1F335}',
  '\u{1F344}',
  '\u{1F334}',
  '\u{1F33A}',
  '\u{1F33C}',
  '\u{1F338}',
  '\u{2618}\u{FE0F}',
  '\u{1F332}',
  '\u{2604}\u{FE0F}',
  '\u{1F31D}',
  '\u{1F31E}',
  '\u{1F950}',
  '\u{1F968}',
  '\u{1F355}',
  '\u{1F354}',
  '\u{1F32E}',
  '\u{1F95F}',
  '\u{1F369}',
  '\u{1F36A}',
  '\u{1F363}',
  '\u{1F366}',
  '\u{2615}',
  '\u{1F36C}',
  '\u{1F353}',
  '\u{1F34A}',
  '\u{1F34C}',
  '\u{1F34E}',
  '\u{1F951}',
  '\u{26BD}',
  '\u{1F3C0}',
  '\u{1F3C8}',
  '\u{26BE}',
  '\u{1F3BE}',
  '\u{1F3B1}',
  '\u{1F94F}',
  '\u{1F3B3}',
  '\u{1F6B4}',
  '\u{26F7}\u{FE0F}',
  '\u{1F47D}',
  '\u{1F916}',
  '\u{1F52E}',
  '\u{1FAA9}',
  '\u{1F451}',
  '\u{1F47B}',
];

export const AVATAR_COLORS = [
  '#00D66F',
  '#8FED8D',
  '#99F13C',
  '#6ECBC1',
  '#00A6F4',
  '#2B7FFF',
  '#00A8EF',
  '#54CAFF',
  '#AD46FF',
  '#E12AFB',
  '#C4A4FF',
  '#FF84DE',
  '#FB2C36',
  '#F6339A',
  '#FF6F6F',
  '#FFF982',
  '#FDD835',
  '#FE9A00',
  '#E6D397',
  '#D7D7D7',
];

export type LinkAvatarProps = {
  content: string;
  color?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  'data-testid'?: string;
};

export const LinkAvatar = ({
  size = 'sm',
  content,
  color = '#00D66F',
  'data-testid': testId,
}: LinkAvatarProps) => {
  // To determine the first letter of the content, we attempt to be as Unicode-aware
  // as one can be in JavaScript (which is, unfortunately, not easy to do).
  // Normalizing the string and grabbing the first code point should work in most
  // cases, but if the first glyph is a combined sequence, it may not display the
  // exact right glyph.
  let avatarLetter = (content || '').normalize();
  const firstCodePoint = avatarLetter.codePointAt(0);
  if (avatarLetter.length > 0 && firstCodePoint) {
    avatarLetter = String.fromCodePoint(firstCodePoint).toLocaleUpperCase();
  }

  // If the content is an emoji, use the content, otherwise use the first letter
  const isEmoji = AVATAR_EMOJIS.includes(content);
  const finalContent = isEmoji ? content : avatarLetter;

  const sizeMap = {
    xs: '32px',
    sm: '56px',
    md: '80px',
    lg: '120px',
  };

  const fontSizeMap = {
    xs: isEmoji ? '18px' : '16px',
    sm: isEmoji ? '28px' : '24px',
    md: isEmoji ? '40px' : '36px',
    lg: isEmoji ? '64px' : '48px',
  };

  return (
    <view.div
      data-testid={testId || 'link-avatar'}
      css={{
        width: css.value(sizeMap[size]),
        height: css.value(sizeMap[size]),
        minWidth: css.value(sizeMap[size]),
        backgroundColor: css.value(color),
        borderRadius: 'rounded',
        stack: 'x',
        alignX: 'center',
        alignY: 'center',
        fontSize: css.value(fontSizeMap[size]),
        fontWeight: isEmoji ? 'regular' : 'semibold',
        color: css.value('#FFFFFF'),
      }}
    >
      {finalContent}
    </view.div>
  );
};

export default LinkAvatar;
